export default {
  sk: {
    message:
      '🍪Ľúbime cookies! A používame aj tie digitálne. Prečítajte si ako.',
    dismiss: 'PRIJAŤ',
    link: 'Ochrana osobných údajov',
    href: '/gdpr.pdf',
  },
  en: {
    message:
      '🍪We love cookies! And we also use these digital ones. Learn how we use them.',
    dismiss: 'ACCEPT',
    link: 'Personal Data Protection',
    href: '/gdpr.pdf',
  },
};



// WEBPACK FOOTER //
// ./src/scripts/modules/CookieConsent/data.js